/** Chrome, Firefox and Safari each phrase a failed dynamic `import()` differently. */
const STALE_CHUNK_MESSAGES = [
  /Failed to fetch dynamically imported module/i,
  /error loading dynamically imported module/i,
  /Importing a module script failed/i,
  /ChunkLoadError/,
];

const RELOADED_AT_KEY = 'lari.chunkReloadedAt';

/**
 * Long enough that a chunk which is genuinely gone cannot reload the tab in a loop, short enough
 * that a tab left open across two deploys still recovers from the second one on its own.
 */
const RELOAD_COOLDOWN_MS = 10 * 60_000;

/**
 * A chunk that vanished mid-session is a deploy, not a defect: reloading fetches an index.html that
 * names the files which now exist. The allowance is claimed in sessionStorage, because the reload
 * wipes anything held in memory, and it is per tab — the stale index.html is what that tab is
 * running. A failure that cannot claim it reports like any other, which is how a deploy the reload
 * could not fix becomes visible.
 */
export const claimStaleChunkReload = (message: string): boolean => {
  if (!STALE_CHUNK_MESSAGES.some(pattern => pattern.test(message))) {
    return false;
  }
  const now = Date.now();
  try {
    if (now - Number(sessionStorage.getItem(RELOADED_AT_KEY)) < RELOAD_COOLDOWN_MS) {
      return false;
    }
    sessionStorage.setItem(RELOADED_AT_KEY, String(now));
  } catch {
    // Private-mode Safari throws on any access, and with no marker there is nothing to stop a loop.
    return false;
  }
  return true;
};
